var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0237 2.28638L18.8718 5.67414L24.0237 9.06191C27.6351 9.06191 30.5733 12.0002 30.5733 15.6116V19.2252L33.9611 22.613L37.3489 19.2252V15.6116C37.3489 8.26414 31.3711 2.28638 24.0237 2.28638V2.28638Z",
    fill: "#9EA2E3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3672 5.67414C22.3672 4.34974 22.9786 3.09952 24.0239 2.28638C16.6765 2.28638 10.6987 8.26414 10.6987 15.6116V19.2252L14.0865 22.613L17.4743 19.2252V15.6116C17.4743 12.0002 20.4125 9.06191 24.0239 9.06191C22.9786 8.24876 22.3672 6.99854 22.3672 5.67414Z",
    fill: "#8288CB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5566 19.2251H19.2747V45.7136H38.5566C40.4583 45.7136 41.9999 44.1668 41.9999 42.2586V22.6801C41.9999 20.7721 40.4583 19.2251 38.5566 19.2251Z",
    fill: "#FFCE71"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.718 42.2586V22.6801C22.718 20.7721 24.2596 19.2251 26.1613 19.2251H9.44313C7.5415 19.2251 5.99988 20.772 5.99988 22.6801V42.2586C5.99988 44.1668 7.5415 45.7136 9.44313 45.7136H26.1613C24.2596 45.7136 22.718 44.1668 22.718 42.2586Z",
    fill: "#FFB357"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocker);
export default __webpack_public_path__ + "static/media/locker.a24d2fca7be63a4c2a10d16580060dae.svg";
export { ForwardRef as ReactComponent };